// Phonetic data for words with syllable breakdown, vowels, and consonants
export const phoneticData = {
  'afternoon': {
    word: 'afternoon',
    phonetic: '/ ˌɑːftərˈnuːn /',
    syllables: [
      {
        text: 'af',
        phonetic: '/ ɑːf /',
        vowels: ['ɑː'],
        consonants: ['f'],
        type: 'syllable'
      },
      {
        text: 'ter',
        phonetic: '/ tər /',
        vowels: ['ə'],
        consonants: ['t', 'r'],
        type: 'syllable'
      },
      {
        text: 'noon',
        phonetic: '/ nuːn /',
        vowels: ['uː'],
        consonants: ['n', 'n'],
        type: 'syllable'
      }
    ],
    definition: 'n. 下午，午后',
    example: "I'll see you this afternoon."
  },
  'father': {
    word: 'father',
    phonetic: '/ ˈfɑːðər /',
    syllables: [
      {
        text: 'fa',
        phonetic: '/ fɑː /',
        vowels: ['ɑː'],
        consonants: ['f'],
        type: 'syllable'
      },
      {
        text: 'ther',
        phonetic: '/ ðər /',
        vowels: ['ə'],
        consonants: ['ð', 'r'],
        type: 'syllable'
      }
    ],
    definition: 'n. 父亲；祖先',
    example: 'My father is a teacher.'
  },
  'mother': {
    word: 'mother',
    phonetic: '/ ˈmʌðər /',
    syllables: [
      {
        text: 'mo',
        phonetic: '/ mʌ /',
        vowels: ['ʌ'],
        consonants: ['m'],
        type: 'syllable'
      },
      {
        text: 'ther',
        phonetic: '/ ðər /',
        vowels: ['ə'],
        consonants: ['ð', 'r'],
        type: 'syllable'
      }
    ],
    definition: 'n. 母亲',
    example: 'My mother cooks delicious food.'
  },
  'grandmother': {
    word: 'grandmother',
    phonetic: '/ ˈɡrændˌmʌðər /',
    syllables: [
      {
        text: 'grand',
        phonetic: '/ ɡrænd /',
        vowels: ['æ'],
        consonants: ['ɡ', 'r', 'n', 'd'],
        type: 'syllable'
      },
      {
        text: 'mo',
        phonetic: '/ mʌ /',
        vowels: ['ʌ'],
        consonants: ['m'],
        type: 'syllable'
      },
      {
        text: 'ther',
        phonetic: '/ ðər /',
        vowels: ['ə'],
        consonants: ['ð', 'r'],
        type: 'syllable'
      }
    ],
    definition: 'n. 祖母，外祖母',
    example: 'My grandmother tells wonderful stories.'
  },
  'teacher': {
    word: 'teacher',
    phonetic: '/ ˈtiːtʃər /',
    syllables: [
      {
        text: 'tea',
        phonetic: '/ tiː /',
        vowels: ['iː'],
        consonants: ['t'],
        type: 'syllable'
      },
      {
        text: 'cher',
        phonetic: '/ tʃər /',
        vowels: ['ə'],
        consonants: ['tʃ', 'r'],
        type: 'syllable'
      }
    ],
    definition: 'n. 教师，老师',
    example: 'The teacher explains the lesson clearly.'
  }
};

// Vowel and consonant sound data
export const soundData = {
  vowels: {
    'ɑː': { symbol: 'ɑː', description: 'Long A sound', example: 'father', mouthPosition: 'Open, tongue low' },
    'æ': { symbol: 'æ', description: 'Short A sound', example: 'cat', mouthPosition: 'Open, tongue low' },
    'e': { symbol: 'e', description: 'Short E sound', example: 'bed', mouthPosition: 'Mid-open, tongue mid' },
    'iː': { symbol: 'iː', description: 'Long E sound', example: 'see', mouthPosition: 'Close, tongue high' },
    'ɪ': { symbol: 'ɪ', description: 'Short I sound', example: 'sit', mouthPosition: 'Close, tongue high' },
    'oː': { symbol: 'oː', description: 'Long O sound', example: 'more', mouthPosition: 'Mid-open, tongue mid' },
    'uː': { symbol: 'uː', description: 'Long U sound', example: 'moon', mouthPosition: 'Close, tongue high' },
    'ʌ': { symbol: 'ʌ', description: 'Short U sound', example: 'cup', mouthPosition: 'Mid-open, tongue mid' },
    'ə': { symbol: 'ə', description: 'Schwa sound', example: 'about', mouthPosition: 'Neutral, relaxed' }
  },
  consonants: {
    'f': { symbol: 'f', description: 'F sound', example: 'fish', mouthPosition: 'Lower lip touches upper teeth' },
    't': { symbol: 't', description: 'T sound', example: 'top', mouthPosition: 'Tongue touches alveolar ridge' },
    'r': { symbol: 'r', description: 'R sound', example: 'red', mouthPosition: 'Tongue tip curled back' },
    'n': { symbol: 'n', description: 'N sound', example: 'no', mouthPosition: 'Tongue touches alveolar ridge' },
    'm': { symbol: 'm', description: 'M sound', example: 'man', mouthPosition: 'Lips together' },
    'ð': { symbol: 'ð', description: 'TH sound (voiced)', example: 'this', mouthPosition: 'Tongue between teeth' },
    'ɡ': { symbol: 'ɡ', description: 'G sound', example: 'go', mouthPosition: 'Back of tongue touches soft palate' },
    'd': { symbol: 'd', description: 'D sound', example: 'dog', mouthPosition: 'Tongue touches alveolar ridge' },
    'tʃ': { symbol: 'tʃ', description: 'CH sound', example: 'chair', mouthPosition: 'Tongue touches hard palate' }
  }
};

// Helper functions
export const getWordData = (word) => {
  return phoneticData[word.toLowerCase()] || null;
};

export const getAllWords = () => {
  return Object.keys(phoneticData);
};

export const getSyllableSounds = (word) => {
  const wordData = getWordData(word);
  if (!wordData) return [];
  
  return wordData.syllables.map(syllable => ({
    ...syllable,
    vowelSounds: syllable.vowels.map(v => soundData.vowels[v]).filter(Boolean),
    consonantSounds: syllable.consonants.map(c => soundData.consonants[c]).filter(Boolean)
  }));
};
